import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroChicago } from "@/components/site/HeroChicago";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";
import { safeJsonLd } from "@/lib/structured-data";
import { getStLouisStructuredData } from "@/lib/structured-data/st-louis";
import { CITY_FAQS } from "@/content/wp-parity/faqs/city";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapStLouis = lazy(() => import("@/components/site/LocationsMapStLouis").then(m => ({ default: m.LocationsMapStLouis })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/missouri/st-louis")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | St. Louis Hair Transplants + Hair Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in St. Louis, MO with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult!",
      },
      { property: "og:title", content: "Get Your Hair Back | RESTORE® Hair Transplants — St. Louis" },
      {
        property: "og:description",
        content:
          "Top hair restoration team serving St. Louis. Soft, natural, undetectable results.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/missouri/st-louis/" },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/locations/missouri/st-louis/" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getStLouisStructuredData() }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroChicago
          h1="St. Louis Hair Transplants"
          eyebrow="RESTORE® | St. Louis Hair Transplants"
          subheading="RESTORE your confidence with the #1 hair restoration team in St. Louis"
          extraParagraph="Find out about your hair transplant options in St. Louis."
        />
        <NorwoodQuiz />
        <WhyChooseChicago />
        <Suspense fallback={null}>
          <div className="hidden md:block">
            <Results />
          </div>
          <ValueProps hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy dougLeft />
          <Reviews />
          <Guarantee />
          <Pricing city="St. Louis" />
          <VirtualConsult />
          <Surgeons
            eyebrow="RESTORE St. Louis Hair Transplant Doctors"
            heading={<>A World Renowned <span className="text-foreground">Team</span></>}
          />
          <DoctorsGrid />
          <LocationsMapStLouis />
          <Faq items={CITY_FAQS} />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
